/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
'document' in self &&
    (('classList' in document.createElement('_') &&
        (!document.createElementNS ||
            'classList' in document.createElementNS('http://www.w3.org/2000/svg', 'g'))) ||
        !(function (t) {
            if ('Element' in t) {
                let e = 'classList',
                    n = 'prototype',
                    i = t.Element[n],
                    s = Object,
                    r =
                        String[n].trim ||
                        function () {
                            return this.replace(/^\s+|\s+$/g, '');
                        },
                    o =
                        Array[n].indexOf ||
                        function (t) {
                            for (let e = 0, n = this.length; n > e; e++)
                                if (e in this && this[e] === t) return e;
                            return -1;
                        },
                    c = function (t, e) {
                        (this.name = t), (this.code = DOMException[t]), (this.message = e);
                    },
                    a = function (t, e) {
                        if (e === '') throw new c('SYNTAX_ERR', 'The token must not be empty.');
                        if (/\s/.test(e))
                            throw new c(
                                'INVALID_CHARACTER_ERR',
                                'The token must not contain space characters.',
                            );
                        return o.call(t, e);
                    },
                    l = function (t) {
                        for (
                            let e = r.call(t.getAttribute('class') || ''),
                                n = e ? e.split(/\s+/) : [],
                                i = 0,
                                s = n.length;
                            s > i;
                            i++
                        )
                            this.push(n[i]);
                        this._updateClassName = function () {
                            t.setAttribute('class', this.toString());
                        };
                    },
                    u = (l[n] = []),
                    h = function () {
                        return new l(this);
                    };
                if (
                    ((c[n] = Error[n]),
                    (u.item = function (t) {
                        return this[t] || null;
                    }),
                    (u.contains = function (t) {
                        return ~a(this, t + '');
                    }),
                    (u.add = function () {
                        let t,
                            e = arguments,
                            n = 0,
                            i = e.length,
                            s = !1;
                        do (t = e[n] + ''), ~a(this, t) || (this.push(t), (s = !0));
                        while (++n < i);
                        s && this._updateClassName();
                    }),
                    (u.remove = function () {
                        let t,
                            e,
                            n = arguments,
                            i = 0,
                            s = n.length,
                            r = !1;
                        do
                            for (t = n[i] + '', e = a(this, t); ~e; )
                                this.splice(e, 1), (r = !0), (e = a(this, t));
                        while (++i < s);
                        r && this._updateClassName();
                    }),
                    (u.toggle = function (t, e) {
                        let n = this.contains(t),
                            i = n ? e !== !0 && 'remove' : e !== !1 && 'add';
                        return i && this[i](t), e === !0 || e === !1 ? e : !n;
                    }),
                    (u.replace = function (t, e) {
                        const n = a(t + '');
                        ~n && (this.splice(n, 1, e), this._updateClassName());
                    }),
                    (u.toString = function () {
                        return this.join(' ');
                    }),
                    s.defineProperty)
                ) {
                    const f = { get: h, enumerable: !0, configurable: !0 };
                    try {
                        s.defineProperty(i, e, f);
                    } catch (p) {
                        (void 0 !== p.number && p.number !== -2146823252) ||
                            ((f.enumerable = !1), s.defineProperty(i, e, f));
                    }
                } else s[n].__defineGetter__ && i.__defineGetter__(e, h);
            }
        })(self),
    (function () {
        let t = document.createElement('_');
        if ((t.classList.add('c1', 'c2'), !t.classList.contains('c2'))) {
            const e = function (t) {
                const e = DOMTokenList.prototype[t];
                DOMTokenList.prototype[t] = function (t) {
                    let n,
                        i = arguments.length;
                    for (n = 0; i > n; n++) (t = arguments[n]), e.call(this, t);
                };
            };
            e('add'), e('remove');
        }
        if ((t.classList.toggle('c3', !1), t.classList.contains('c3'))) {
            const n = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function (t, e) {
                return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
            };
        }
        'replace' in document.createElement('_').classList ||
            (DOMTokenList.prototype.replace = function (t, e) {
                let n = this.toString().split(' '),
                    i = n.indexOf(t + '');
                ~i &&
                    ((n = n.slice(i)),
                    this.remove.apply(this, n),
                    this.add(e),
                    this.add.apply(this, n.slice(1)));
            }),
            (t = null);
    })());

// IE remove polyfill
(function () {
    function remove() {
        this.parentNode && this.parentNode.removeChild(this);
    }
    if (!Element.prototype.remove) Element.prototype.remove = remove;
    if (Text && !Text.prototype.remove) Text.prototype.remove = remove;
})();
(() => {
    // Array.find() polyfill
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return kValue.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return kValue;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return undefined.
                return undefined;
            },
            configurable: true,
            writable: true,
        });
    }

    // String.startsWith polyfill
    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function (search, pos) {
                pos = !pos || pos < 0 ? 0 : +pos;
                return this.substring(pos, pos + search.length) === search;
            },
        });
    }

    // Array.forEach polyfill
    // Production steps of ECMA-262, Edition 5, 15.4.4.18
    // Reference: http://es5.github.io/#x15.4.4.18
    if (!Array.prototype.forEach) {
        Array.prototype.forEach = (callback /*, thisArg*/) => {
            var T, k;

            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            // 1. Let O be the result of calling toObject() passing the
            // |this| value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get() internal
            // method of O with the argument "length".
            // 3. Let len be toUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If isCallable(callback) is false, throw a TypeError exception.
            // See: http://es5.github.com/#x9.11
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            // 5. If thisArg was supplied, let T be thisArg; else let
            // T be undefined.
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // 6. Let k be 0.
            k = 0;

            // 7. Repeat while k < len.
            while (k < len) {
                var kValue;

                // a. Let Pk be ToString(k).
                //    This is implicit for LHS operands of the in operator.
                // b. Let kPresent be the result of calling the HasProperty
                //    internal method of O with argument Pk.
                //    This step can be combined with c.
                // c. If kPresent is true, then
                if (k in O) {
                    // i. Let kValue be the result of calling the Get internal
                    // method of O with argument Pk.
                    kValue = O[k];

                    // ii. Call the Call internal method of callback with T as
                    // the this value and argument list containing kValue, k, and O.
                    callback.call(T, kValue, k, O);
                }
                // d. Increase k by 1.
                k++;
            }
            // 8. return undefined.
        };
    }

    if (!Array.isArray) {
        Array.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    if (!Function.prototype.isArray) {
        Function.prototype.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    // NodeList/HTML Collection forEach polyfill
    if (!NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach;

    // XMLHttpRequest.overrideMimeType polyfill
    if (!XMLHttpRequest.prototype.overrideMimeType) {
        Object.defineProperty(XMLHttpRequest.prototype, 'overrideMimeType', {
            value: function (mime = null) {
                if (this.readyState === this.LOADING || this.readyState === this.DONE)
                    throw new InvalidStateError(
                        'overrideMimeType() not allowed in LOADING or DONE',
                    );
            },
        });
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return k.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return k;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return -1.
                return -1;
            },
            configurable: true,
            writable: true,
        });
    }
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (searchElement, fromIndex) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                // 1. Let O be ? ToObject(this value).
                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return (
                        x === y ||
                        (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
                    );
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(searchElement, elementK) is true, return true.
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    // c. Increase k by 1.
                    k++;
                }

                // 8. Return false
                return false;
            },
        });
    }

    // ; (() => {
    //   if (typeof window.CustomEvent === "function") return false; //If not IE

    //   function CustomEvent(event, params) {
    //     params = params || { bubbles: false, cancelable: false, detail: undefined };
    //     var evt = document.createEvent('CustomEvent');
    //     evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    //     return evt;
    //   }

    //   CustomEvent.prototype = window.Event.prototype;

    //   window.CustomEvent = CustomEvent;
    // })();
})();
(() => {
    (Number.isNaN =
        Number.isNaN ||
        function (value) {
            return value !== value;
        }),
        false;
})();
// Custom methods
(() => {
    (function () {
        if (typeof window.CustomEvent === 'function') return false;

        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: null };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        window.CustomEvent = CustomEvent;
    }),
        false;
    (Element.prototype.appendBefore = function (element) {
        this.insertAdjacentElement('beforebegin', element);
    }),
        false;
    (Element.prototype.appendAfter = function (element) {
        this.insertAdjacentElement('afterend', element);
    }),
        false;
    (Element.prototype.removeAllChildren = function () {
        while (this.firstChild) {
            this.removeChild(this.firstChild);
        }
    }),
        false;
    (Element.prototype.removeSelf = function () {
        if (this.parentElement) this.parentElement.removeChild(this);
        else console.warn(`${this} does not have a parent element`);
    }),
        false;
    (Element.prototype.attachSpinner = function (options = {}) {
        const element = document.createElement('div');
        element.setAttribute('id', 'spinner');
        if (this.firstElementChild) {
            this.firstElementChild.appendBefore(element);
        } else {
            this.appendBefore(element);
        }
        if (!options || options.overlay || options.overlay === undefined) {
            element.setAttribute(
                'style',
                `content:"";display:flex;height:${
                    options.height || this.getBoundingClientRect().height
                }px;width:${
                    options.width || this.getBoundingClientRect().width
                }px;background:rgba(0, 0, 0, 0.5);position:absolute;z-index:10;`,
            );
        }
        const spinner = document.querySelector('#spinner');
        spinner.innerHTML = `<div style="z-index:11;height:${
            this.getBoundingClientRect().width / 6
        }px; width:${this.getBoundingClientRect().width / 6}px; left:${
            options.left ||
            this.getBoundingClientRect().width / 2 - this.getBoundingClientRect().width / 12 + 'px'
        }; top:${
            options.top ||
            this.getBoundingClientRect().height / 2 - this.getBoundingClientRect().width / 12 + 'px'
        };" class="preloader-wrapper active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div>`;

        const spinnerstopped = new CustomEvent('stopspinning', {
            bubbles: true,
            detail: {
                spinning: false,
            },
        });
        const spinning = new CustomEvent('spinning', {
            bubbles: true,
            detail: {
                spinning: true,
            },
        });
        const stopspinning = new CustomEvent('stopspinning', {
            bubbles: true,
        });

        this.stopSpinner = function (event = stopspinning) {
            this.dispatchEvent(event);
        };
        this.destroySpinner = function (el = element, event = spinnerstopped) {
            el.removeSelf();
            this.dispatchEvent(event);
        };
        this.dispatchEvent(spinning);
        this.addEventListener('stopspinning', this.destroySpinner(element, spinnerstopped));
    }),
        false;
})();



// WEBPACK FOOTER //
// ./app/config/polyfills.js